import {useEffect, useState} from "react";
import styled from 'styled-components';

import {FormControl, useToast} from "@chakra-ui/react";
import {useParams} from "react-router-dom";
import useFeedback from "../../../utils/use_feedback";
import {useCommunitySettings, useReloadCommunity, useSaveSettings} from "../../../api/communities";
import {useSaveClicked} from "../../../store";
import FormContainer from "../../../components/form_container";
import {WhiteMain} from "../../../components/main";
import {FixedTopBar} from "../../../components/top_bar";
import {Select as MultiSelect} from "chakra-react-select";

const topics = [
    "Politics",
    "NSFW",
    "Memes",
    "Culture",
    "Sports",
    "Gaming",
    "Guns",
    "Hobbies",
    "Cars",
    "Videos",
    "Stories",
    "Technology",
    "Streaming",
    "Discussion",
    "Entertainment",
    "Music",
    "Movies",
    "TV",
    "Humor",
    "GIFs",
    "Lifestyle",
    "News",
    "Places",
    "Finance"
];

const TopicsCommunitySettings = styled(({className}) => {
    const {community} = useParams();
    const {error, feedbackCh} = useFeedback();
    const [settings, setSettings] = useState({
            displayName: '',
            appSafe: '',
            description: '',
            topics: [],
            nsfw: false,
        }
    );
    useCommunitySettings(feedbackCh, community, setSettings);
    const set = (name) => (value) => setSettings((settings) => ({...settings, [name]: value}));

    const saveSettings = useSaveSettings(feedbackCh);
    const reloadCommunity = useReloadCommunity(feedbackCh);
    const saveClicked = useSaveClicked();
    const [saving, setSaving] = useState(false);
    const toast = useToast();
    useEffect(() => {
        (async () => {
            if (saveClicked) {
                if (!saving) {
                    setSaving(true);
                    toast({
                        title: `Saving...`,
                        status: 'info',
                        isClosable: true,
                    });
                    await saveSettings(community, settings);
                    await reloadCommunity([community]);
                    toast.closeAll();
                    toast({
                        title: `Saved settings.`,
                        status: 'success',
                        isClosable: true,
                    });
                    setSaving(false);
                }
            }
        })().then(() => {
        }, () => {
        });
    }, [saveClicked]);

    return (
        <>
            <FixedTopBar back title="Community Topics" border={false} save/>
            <WhiteMain className={className}>
                <FormContainer>

                    <p>Community Topics help new users find your community. If your community allows any political
                        content, you must tag your community as Politics.</p>

                    <FormControl mb={4}>
                        <MultiSelect
                            isMulti
                            name="topics"
                            value={settings.topics}
                            options={topics}
                            getOptionLabel={option => option}
                            getOptionValue={option => option}
                            placeholder="Select topics..."
                            closeMenuOnSelect={false}
                            onChange={set('topics')}
                        />
                    </FormControl>

                </FormContainer>
            </WhiteMain>
        </>
    );
})`
p {
font-size: 15px;
padding-bottom: 12px;
}
  ${FormContainer} {
    background-color: ${({theme}) => theme.color.name === 'dark' ? 'transparent' : theme.white_0};
    padding: 16px 20px;
  }
`;

export default TopicsCommunitySettings;
